import { fetchItemDetailsIfNeeded, getItemDetail } from './itemDetail';
import { fetchItemFacetsIfNeeded, getItemFacets } from './itemFacets';
import { fetchItemsIfNeeded, getItem } from './item';
import { fetchSimilarItemsV3IfNeeded, getSimilarItemIds } from './similarItemsV3';
import { fetchBidHistoryIfNeeded } from './bidHistory';
import { fetchBidLimitBalanceIfNeeded } from './bidLimit';
import { fetchCatalogAnnouncementIfNeeded } from './catalogAnnouncement';
import { fetchCatalogBiddingIfNeeded } from './catalogBiddingInfo';
import { fetchCatalogCuratorsIfNeeded } from './catalogCurators';
import { fetchCatalogDetailsIfNeeded } from './catalogDetail';
import { fetchCatalogItemsIfNeeded } from './catalogItems';
import { fetchCurrencyConversionsIfNeeded } from '@/redux/modules/currency';
import { fetchDiscoverPageSuggestions } from './discoverPageSuggestions';
import { fetchItemBiddingIfNeeded } from './biddingInfo';
import { fetchItemShippingsIfNeeded } from './itemShipping';
import { fetchListingAgentsIfNeeded } from './listingAgent';
import { fetchLiveCatalogStatusIfNeeded } from './liveCatalogStatus';
import { fetchSavedItemCountsIfNeeded } from './savedItemCount';
import { fetchSellerFollowerCountIfNeeded } from './sellerFollowerCount';
import { fetchSellerRatingsByIdIfNeeded } from './sellerRatings';
import { fetchSellersDetailsIfNeeded } from './sellerDetail';
import { fetchSimilarSoldItemsV3IfNeeded } from './similarSoldItemsV3';
import { fetchTopSellersIfNeeded } from './topRatedSellers';
import { fetchUpcomingCatalogRegistrationIfNeeded } from './catalogRegistration';
import { getCatalog } from './catalog';
import { getFacetIds } from '@/utils/ItemPageUtils';
import { getNotFoundUrl } from '@/utils/urls';
import { push } from 'connected-react-router';

/* ACTION CREATORS */
export const fetchDataForItemPage = (itemId: number) => async (dispatch: Function, getState: Function) => {
    await Promise.all([
        dispatch(fetchItemDetailsIfNeeded([itemId])),
        dispatch(fetchItemFacetsIfNeeded([itemId])),
        dispatch(fetchItemShippingsIfNeeded([itemId])),
        dispatch(fetchItemsIfNeeded([itemId])),
        dispatch(fetchSavedItemCountsIfNeeded([itemId])),
        dispatch(fetchTopSellersIfNeeded()),
        dispatch(fetchCurrencyConversionsIfNeeded()),
        dispatch(fetchItemBiddingIfNeeded(itemId)),
    ]);

    const item = getItem(getState(), itemId);
    const itemDetail = getItemDetail(getState(), itemId);
    const facets = getItemFacets(getState(), itemId);
    const categoryIds = getFacetIds(facets);

    if (!item.itemId || item.isDeleted) {
        return dispatch(push(getNotFoundUrl()));
    }

    const { catalogId, index, sellerId, title } = item;
    const { agentId } = itemDetail;
    const similarItemInfo = {
        categoryIds,
        itemId,
        sellerId,
        title,
    };

    await Promise.all([
        dispatch(fetchDiscoverPageSuggestions(title)),
        dispatch(fetchUpcomingCatalogRegistrationIfNeeded(catalogId)),
        dispatch(fetchCatalogAnnouncementIfNeeded(catalogId, sellerId)),
        dispatch(fetchBidLimitBalanceIfNeeded(catalogId)),
        dispatch(fetchCatalogCuratorsIfNeeded(catalogId)),
        dispatch(fetchCatalogDetailsIfNeeded([catalogId])),
        dispatch(fetchListingAgentsIfNeeded([agentId])),
        dispatch(fetchSellersDetailsIfNeeded([sellerId])),
        dispatch(fetchSellerFollowerCountIfNeeded([sellerId])),
        dispatch(fetchSellerRatingsByIdIfNeeded({ sellerId })),
        dispatch(fetchSimilarItemsV3IfNeeded(similarItemInfo)),
    ]);

    const state = getState();
    const catalog = getCatalog(state, catalogId);
    const promises = [];

    const similarItemIds = getSimilarItemIds(state, itemId);

    promises.push(dispatch(fetchItemsIfNeeded(similarItemIds)));

    if (catalogId && catalog) {
        if (catalog.catalogStatus === 'live') {
            promises.push(dispatch(fetchLiveCatalogStatusIfNeeded(catalogId, true)));
        } else if (catalog.catalogStatus === 'done') {
            promises.push(dispatch(fetchSimilarSoldItemsV3IfNeeded(similarItemInfo)));
            promises.push(dispatch(fetchBidHistoryIfNeeded(itemId)));
        }
        const prevIndex = index - 5 < 0 ? 0 : index - 5;
        promises.push(dispatch(fetchCatalogItemsIfNeeded(catalogId, prevIndex, 1, 25)));
    }
    promises.push(dispatch(fetchCatalogBiddingIfNeeded(catalogId)));

    return Promise.all(promises);
};
